import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * shadcn/ui 类名合并工具:clsx 条件拼接 + tailwind-merge 冲突消解。
 * registry 组件统一从这里 import { cn } from "@/lib/utils"。
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
